import { ScaffoldSectionScaffoldData } from './scaffold-section-scaffold-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class StockReportScaffoldSubsection {
  IsEmpty: boolean;
  DepotId: string;
  DepotName: string;
  SiteId: string;
  SiteName: string;
  SiteNumber: string;
  SiteAddress: string;
  CustomerId: string;
  CustomerName: string;
  ContractId: string;
  ContractName: string;
  ContractNumber: string;
  Scaffolds: ScaffoldSectionScaffoldData[];
}


